import React, { memo, useCallback } from 'react';
import Div from '@/shared/Div';
import Heading from '@/shared/Heading';
import RecentViewCard from '@/shared/crisp/RecentViewCard';
import Container from '@/shared/Container';
import Map from '@/components/Map';
interface RecentlyViewedProps {
  title: string;
  list: any[];
}

const RecentlyViewed = (props: RecentlyViewedProps) => {
  const { title, list = [] } = props;

  const render = useCallback(
    (product: any) => (
      <RecentViewCard key={product.plainName} name={product.plainName} {...product} />
    ),
    [],
  );

  if (list.length === 0) return null;

  return (
    <Div className="py-s6 bg-cs-secondary">
      <Container className="flex flex-col">
        <Heading
          level={3}
          className="text-h-3 md:text-hd-3 md:text-center font-extrabold text-cm-primary"
        >
          {title}
        </Heading>
        <Map
          className="overflow-x-auto whitespace-nowrap hide-scrollbar flex gap-s5 mt-s6 -mx-6 px-s6"
          list={list}
          render={render}
        />
      </Container>
    </Div>
  );
};

export default memo(RecentlyViewed);
